export enum FeatureToggle {
  storeConfiguration = 'rt_store_configuration',
  dmsDraftTableEnabled = 'rt_dms_draft_table_enabled',
}
